export default "float circularOut(float t) {\n  return sqrt((2.0 - t) * t);\n}\n\n"